var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 140,
    viewBox: "0 0 143 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.588 131.765C135.064 131.765 142.745 124.083 142.745 114.608C142.745 105.132 135.064 97.4509 125.588 97.4509C116.113 97.4509 108.431 105.132 108.431 114.608C108.431 124.083 116.113 131.765 125.588 131.765Z",
    fill: "#11263C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4455 57.617L81.6471 49.8269C81.0935 49.2733 80.2025 49.2733 79.6488 49.827C79.095 50.3808 79.095 51.2718 79.6488 51.8255L85.0331 57.2099H51.4481C50.664 57.2099 50.0294 57.8445 50.0294 58.6286C50.0294 59.4127 50.664 60.0473 51.4481 60.0473H85.0313L79.6492 65.4148C79.095 65.9689 79.095 66.8599 79.6488 67.4137C79.9189 67.6839 80.2757 67.829 80.6522 67.829C81.0286 67.829 81.3854 67.6839 81.6555 67.4137L89.4537 59.6155C90.001 59.0682 89.9974 58.1689 89.4455 57.617ZM60.2497 74.5765C60.8034 74.0227 60.8034 73.1317 60.2497 72.578C59.6959 72.0242 58.8049 72.0242 58.2512 72.578L50.453 80.3762C49.8992 80.9299 49.8992 81.8209 50.453 82.3747L58.2512 90.1729C58.5214 90.443 58.8781 90.5882 59.2546 90.5882C59.631 90.5882 59.9878 90.443 60.2579 90.1729C60.8117 89.6191 60.8117 88.7281 60.2579 88.1743L54.8736 82.79H88.4586C89.2303 82.79 89.8608 82.1595 89.8608 81.3795C89.8608 80.5954 89.2262 79.9608 88.4421 79.9608H54.8653L60.2497 74.5765Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.763 115.294L117.11 109.641C116.519 109.05 116.519 108.093 117.11 107.502C117.7 106.911 118.658 106.911 119.249 107.502L124.902 113.155L130.555 107.502C131.146 106.911 132.103 106.911 132.694 107.502C133.285 108.093 133.285 109.05 132.694 109.641L127.041 115.294L132.694 120.947C133.285 121.538 133.285 122.496 132.694 123.086C132.103 123.677 131.146 123.677 130.555 123.086L124.902 117.433L119.249 123.086C118.658 123.677 117.7 123.677 117.11 123.086C116.519 122.496 116.519 121.538 117.11 120.947L122.763 115.294Z",
    fill: "#FF3361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4e9d4dc8.svg";
export { ForwardRef as ReactComponent };